import { BaseResponse, BaseExchange } from '~/sdk/shared'
import API from  '~/sdk/client'

export type Entity = {
  url: string
}

export type Payload = {
  productType: 'FACTORING'| 'QUICK_LOAN'| 'BUSINESS_LOAN'
  month: string
}

export async function post(payload: BaseExchange<Payload>): Promise<BaseResponse<Entity>> {
  return await API.post('/internal/v1/company/reports/financial-summary-monthly', payload)
}
